import { Container, Grid, Box, TableContainer, Table } from '@mui/material'
import type { FC } from 'react'

import PageContentStickyBar from '@/components/UI/PageContentStickyBar'

interface Props {
  isNavigationDrawerOpen: boolean
  yOffset: number
}

const PageContentStickyTableHeader: FC<Props> = ({
  children,
  isNavigationDrawerOpen,
  yOffset,
}) => (
  <PageContentStickyBar isNavigationDrawerOpen={isNavigationDrawerOpen} yOffset={yOffset}>
    <Container maxWidth="xl">
      <Grid container>
        <Grid item xs={12}>
          <Box sx={{ padding: '20px', paddingBottom: 0 }}>
            <TableContainer>
              <Table aria-label="simple table" size="small">
                {children}
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </Container>
  </PageContentStickyBar>
)

export default PageContentStickyTableHeader
